<template>
<div class="grocery-list-tabs">
  <b-tabs content-class="mt-4" v-if="!this.isEmbed">
    <b-tab :title="this.$t('lblAll')" active>
      <BaseGroceryListItem
        v-for="(item, i) in groceryList"
        :key="item.id"
        :item="item"
        :isCategory="true"
        :onTabletUp="onTabletUp"
        @select-item="onSelectItem"
      />
    </b-tab>
    <b-tab :title="this.$t('lblFresh')">
      <BaseGroceryListItem
        v-for="item in $options.filters.filterItems(this.groceryList, 'Fresh')"
        :key="item.id"
        :item="item"
        :isCategory="true"
        @select-item="onSelectItem"
      />
    </b-tab>
    <b-tab :title="this.$t('lblPantry')">
      <BaseGroceryListItem
        v-for="item in $options.filters.filterItems(this.groceryList, 'Pantry')"
        :key="item.id"
        :item="item"
        :isCategory="true"
        @select-item="onSelectItem"
      />
    </b-tab>
  </b-tabs>

  <div v-if="this.isEmbed">
    <BaseGroceryListItem v-for="item in groceryList" :key="item.id" :item="item" :isCategory="true" @select-item="onSelectItem" />
  </div>
</div>
</template>

<script>
import store from '@state/store';
import environment from '@src/environment';
import { kitchenDrawerMethods } from '@state/helpers';

export default {
  components: {},
  props: {
    groceryList: {
      type: Array,
      default: () => [],
    },
    isEmbed: {
      type: Boolean,
    },
    onTabletUp: {
      type: Boolean,
    },
  },
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  methods: {
    ...kitchenDrawerMethods,
    onSelectItem(item) {
      /* if (!this.onTabletUp) {
        this.$emit('select-item', item);
        this.navigateDeeper({
          title: item.name,
          component: 'BaseGroceryListDetail',
          data: item,
        });
      } */
    },
  },
  filters: {
    filterItems(items, cat) {
      if (items) {
        return items.filter((item) => item.parentCategory === cat);
      }
    },
  },
};
</script>

<style lang="scss">
@import 'theme.scss';

.grocery-list-tabs {
  .nav-tabs {
    border-bottom: 0;
    padding-left: 1.5rem;
    padding-right: 1.5rem;

    .nav-item {
      margin-right: 2.4rem;
    }

    a.nav-link {
      border: 0;
      color: $color-grocery-list-tab-link;
      padding: 0 0 0.5rem;

      &.active {
        border: 0;
        border-bottom: 3px solid $color-grocery-list-tab-active;
        color: $color-grocery-list-tab-link-active;
      }
    }
  }

  .tab-pane.active {
    max-height: 94vh;
    overflow: scroll;
    padding-bottom: 19rem;
  }
}
</style>
